import React from 'react';

const BOMForm = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center p-4">
        <div className="w-full md:w-1/2 p-2"> 
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Glass Front</label>
                <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
                    <option value="">Select</option>
                    <option value="">Borosil</option>
                </select>
            </div>
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Encapsulation Front</label>
                <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
                    <option value="">Select</option>
                    <option value="">Borosil</option>
                </select>
            </div>
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Junction Box</label>
                <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
                    <option value="">Select</option>
                    <option value="">Borosil</option>
                </select>
            </div>
        </div>
        <div className="w-full md:w-1/2 p-2 mb-2">
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Glass Rear</label>
                <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
                    <option value="">Select</option>
                    <option value="">Borosil</option>
                </select>
            </div>
            <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Encapsulation Rear</label>
                <select className="w-full p-2 border rounded bg-gray-200 focus:outline-none focus:ring-2 focus:ring-customBlue">
                    <option value="">Select</option>
                    <option value="">Borosil</option>   
                </select>
            </div>
            <div className="mb-4 flex justify-center">
                <button className="bg-customBlue text-white p-2 rounded-md">Submit</button>
            </div>
        </div>
    </div>
  );
};

export default BOMForm;
